// src/components/content/HktAiAssistant.tsx
import React, { useEffect, useState } from 'react';

const HktAiAssistant: React.FC = () => {
    const npid = window.myAppStrapi && window.myAppStrapi.npid ? window.myAppStrapi.npid : '';
    const nowSessionId = window.myAppStrapi && window.myAppStrapi.nowSessionId ? window.myAppStrapi.nowSessionId : '';
    const userAgenth = navigator.userAgent || '';
    const loginUrl = window.myAppStrapi && window.myAppStrapi.loginUrl ? window.myAppStrapi.loginUrl : '';
    const logoutUrl = window.myAppStrapi && window.myAppStrapi.logoutUrl ? window.myAppStrapi.logoutUrl : '';
    const entitlement = window.myAppStrapi && window.myAppStrapi.entitlement ? window.myAppStrapi.entitlement : '';
    const fsaType = window.myAppStrapi && window.myAppStrapi.fsaType ? window.myAppStrapi.fsaType : '';
    
    const [NpidMatching, setNpidMatching] = useState(false);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        // Get URL parameter 'npid' from URL
        const urlParams = new URLSearchParams(window.location.search);
        const urlNpid = urlParams.get('npid');
        
        // Enhanced debug logging
        console.log('HktAiAssistant: URL npid:', urlNpid);
        console.log('HktAiAssistant: myAppStrapi npid:', npid);
        console.log('HktAiAssistant: npids match:', urlNpid === npid);
        
        // Check entitlement responseCode first
        let entitlementResponseCode = '';
        if (entitlement) {
            try {
                // Parse entitlement if it's a JSON string
                const entitlementObj = typeof entitlement === 'string' ? JSON.parse(entitlement) : entitlement;
                entitlementResponseCode = entitlementObj.responseCode || '';
            } catch (error) {
                console.warn('HktAiAssistant: Failed to parse entitlement:', error);
            }
        }
        
        // Debug logging
        console.log('HktAiAssistant: Full entitlement object:', entitlement);
        console.log('HktAiAssistant: Extracted responseCode:', entitlementResponseCode);
        console.log('HktAiAssistant: responseCode type:', typeof entitlementResponseCode);
        console.log('HktAiAssistant: Is entitlement truthy?', !!entitlement);
        console.log('HktAiAssistant: Entitlement typeof:', typeof entitlement);
        
        // Check npid logic: if no URL npid OR npids match, proceed with entitlement check
        if (!urlNpid || (urlNpid && npid && urlNpid === npid)) {
            setNpidMatching(true);
            
            // if (entitlementResponseCode && entitlementResponseCode.toUpperCase() === 'NEED_SUB') {
            //     // User needs subscription - redirect to get-started with library ID
            //     console.log('HktAiAssistant: NEED_SUB detected, redirecting to get-started');
            //     window.location.href = '/get-started?libid=L00228';
            //     return;
            // } else 
            //     if (entitlementResponseCode && (entitlementResponseCode.toUpperCase() === 'SUCCESS' || entitlementResponseCode.toUpperCase() === 'NEED_SUB')) {
                // User has valid entitlement - continue to QA assistant
                // If we have a nowSessionId available, set it as a cross-subdomain cookie
                // so qa-hktaiasst.now.com can receive it on navigation. Note: this is
                // a non-HttpOnly cookie (set from JS). For stronger security prefer a
                // server-set HttpOnly cookie.
                try {
                    if (nowSessionId) {
                        const cookieValue = encodeURIComponent(nowSessionId);
                        // Set cookie for all subdomains of now.com
                        document.cookie = `nowSessionId=${cookieValue};domain=.now.com;path=/;SameSite=None;Secure;max-age=315569260`;
                    } else {
                        // no session id available locally — we'll still redirect
                        console.warn('HktAiAssistant: nowSessionId not present; redirecting without setting cookie');
                    }
                } catch (err) {
                    // In case document.cookie is unavailable or blocked
                    // eslint-disable-next-line no-console
                    console.warn('HktAiAssistant: failed to set cookie', err);
                }

                // Redirect to https://now-tv.now.com/ai-assistant if npid match and entitlement is SUCCESS
                window.location.href = 'https://now-tv.now.com/ai-assistant';
            // } else {
            //     // Unknown or missing responseCode - show login again screen
            //     console.warn('HktAiAssistant: Unknown entitlement responseCode:', entitlementResponseCode);
            //     setNpidMatching(false);
            // }
        } else {
            // URL npid exists but doesn't match myAppStrapi npid
            setNpidMatching(false);
        }
        
        // Set loading to false after processing
        setLoading(false);
    }, [npid, nowSessionId, entitlement]);

    useEffect(() => {
        console.log('HktAiAssistant entitlement from react:', entitlement);
        console.log('HktAiAssistant fsaType from react:',  fsaType);
    }, [entitlement,  fsaType]);

    const handleLoginAgain = () => {
        if (logoutUrl) {
            window.location.href = logoutUrl;
        }
    };

    if (loading) {
        return (
            <>
                <div id="loader">
                    <div className="spinner-border"></div>
                </div>
            </>
        );
    }

    if (!NpidMatching) {
        return (
      <>
        <style>{`
          .btn.btn-primary {
            background-color: #ef9528;
            color: #fff;
            border: none;
          }
        `}</style>
        <section id="main-content">
          <div className="container-fluid my-5">
            <div className="page-wrapper text-center">
                <div className="heading mt-2 mb-5">
                    <h2>Please login with the Now ID from your Now TV App</h2>
                </div>
                <button className="btn btn-primary" onClick={handleLoginAgain}>
                    Login Again
                </button>
            </div>
        </div>
        </section>
      </>
        );
    }

    // This return should not be reached if NPIDs match (due to redirect)
    return (
            <>
                <div id="loader">
                    <div className="spinner-border"></div>
                </div>
            </>
    );
};

export default HktAiAssistant;